import { Component, Input, OnInit } from '@angular/core';
import { CommonMessages } from '@app/constants/common.messages';
import { Competency } from '@app/domain/competency/model/competency.model';
import { Globals } from '@app/shared/globals/globals';
import { PillType } from '../../pill/pill.component';
import { CompanyFeatures } from '@app/models/company-features.model';
import { CompetencyRating } from '@app/domain/competency/model/competency-rating.model';
import { CompetencyRatingConfiguration } from '@app/domain/competency/model/competency-rating-configuration.model';
import { CompetencyRatingOption } from '@app/domain/competency/model/competency-rating-option.model';

@Component({
  selector: 'app-competency-display',
  templateUrl: './competency-display.component.html',
  styleUrls: ['./competency-display.component.scss']
})
export class CompetencyDisplayComponent implements OnInit {

  public readonly eCompanyFeatures = CompanyFeatures;
  public readonly eCommonMessages = CommonMessages;
  public readonly ePillType = PillType;

  @Input() competency: Competency;
  @Input() competencyRating?: CompetencyRating;
  @Input() competencyRatingConfiguration?: CompetencyRatingConfiguration;
  @Input() showScore: boolean;

  metadata: CompetencyRatingOption;

  dropdownExpanded: boolean;

  constructor(
    public globals: Globals
  ) {
    this.competency = undefined!;
    this.dropdownExpanded = false;
    this.showScore = true;
  }

  toggleDropdown(): void {
    this.dropdownExpanded = !this.dropdownExpanded;
  }

  ngOnInit(): void {
    if (this.competencyRatingConfiguration && this.competencyRating && this.competencyRating.scoreValue !== -1) {
      this.metadata = this.competencyRatingConfiguration.getOption(this.competencyRating.scoreValue);
    }
  }

}
